import { compose, branch, renderComponent } from 'recompose';
import { connect } from 'react-redux';
import SearchPage from './SearchPage';
import NewSearchPage from './NewSearchPage';

const enhance = compose(
	connect((state, props) => {
		// Parse query params from the location (if present)
		const params = props.location
			? new URLSearchParams(props.location.search)
			: new URLSearchParams('');
		const queryParams = props.location ? Object.fromEntries(params) : {};

		// Experiment flag we need to implement once it is active in the gateway
		const isNewSearchPage =
			state.experiments?.bucket?.sf_16978_ssdc_clp_redesign ==
			'variation';

		return {
			useNewSearch: isNewSearchPage,
			queryParams,
		};
	}),
	branch(
		(props) => props.useNewSearch,
		compose(renderComponent(NewSearchPage)),
	),
);

export default enhance(SearchPage);
